// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["css/email"], () => (__webpack_require__("./resources/js/main.js")))
__webpack_require__.O(undefined, ["css/email"], () => (__webpack_require__("./resources/scss/main.scss")))
__webpack_require__.O(undefined, ["css/email"], () => (__webpack_require__("./resources/scss/editor.scss")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["css/email"], () => (__webpack_require__("./resources/scss/email.scss")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
